export class FetchUser {
    static readonly type = '[User] FetchUser';

    constructor(public payload: string) {}
}
